var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g;
import { Notifier } from "@//common/utils/notifier";
import { ScaleRangeModel } from "@/app//models/scale-range.model";
import { Feature, EventsClient, CompaniesClient, GetChargeCycleSnapshotListPaginatedQuery, GetSystemTrendChartLimitQueryModel, GetSystemTrendChartQuery, GetSystemDischargeCSVQuery, GetDischargePDFReportQuery, GetSystemTrendChartQueryModel, LookupsClient, MeasurementCategoryModel, MeasurementDataSourceEnum, PaginatedEnumerableOfChargeCycleSnapshotModel, SortDescription, SortDirection, StringStatusEnum, SystemComponentTreeModel, SystemComponentTreeNodesClient, SystemsClient, SystemTrendClient, TimeseriesChart, BatteryTypeEnum, LithiumBatteryTypeEnum } from "@/app/api/battery-portal-api";
import { SelectableDatasetModel } from "@/app/models/selectable-dataset.model";
import { LoginState } from "@/app/store/modules/login.state";
import { LicenseState } from "@/app/store/modules/license.state";
import { AssureEditionEnum } from "@/app/api/battery-portal-api";
import store from "@/app/store/store";
import { ArrayHelper } from "@/app/utils/array-helper";
import { DateHelper } from "@/app/utils/date-helper";
import { HttpHelper } from "@/app/utils/http-helper";
import { MeasurementHelper } from "@/app/utils/measurement-helper";
import QueryStringHelper from "@/app/utils/querystring-helper";
import { DownloadUtil } from "@/app/utils/download-util";
import DischargeGraphAxisVue from "@/app/vues/charts/discharge-graph-axis.vue";
import VerticalSplitterVue from "@/app/vues/components/vertical-splitter.vue";
import AutomaticDischargeReportSettingsVue from "@/app/vues/reports/automatic-discharge-report-settings.vue";
import { DatePresetOption } from "@/common/enums/date-preset";
import Sorter from "@/common/utils/sorter";
import { Component, Vue, Watch, Ref } from "vue-facing-decorator";
import { defineAsyncComponent, nextTick } from "vue";
const TrendGraphVue = defineAsyncComponent(() => import(/* webpackChunkName: "charts" */ "@/app/vues/charts/trend-graph.vue"));
import { State } from "vuex-facing-decorator";
import moment from "moment";
import pako from 'pako';
const eventsClient = new EventsClient(window.apiUrl);
const systemTrendClient = new SystemTrendClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const systemsClient = new SystemsClient(window.apiUrl);
const systemComponentTreeNodesClient = new SystemComponentTreeNodesClient(window.apiUrl);
const lookupsClient = new LookupsClient(window.apiUrl);
const queryStringHelper = new QueryStringHelper();
let DischargeVue = class DischargeVue extends Vue {
    constructor() {
        super(...arguments);
        this.defaultLineWidth = 1;
        this.defaultPointRadius = 3;
        this.useImperialMeasurementSystem = store.getters["loginModule/isUsingImperialMeasurementSystem"];
        this.componentKey = 0;
        this.working = false;
        this.chartLoaded = false;
        this.searchAttempted = false;
        this.showAutomaticReportSettingsModal = false;
        this.isLoadingQueryString = false;
        this.datePickerConfig = DateHelper.GetDefaultDatePickerConfig();
        this.dateFilterOptions = ["W", "M", "3M", "Y", "..."];
        this.dateFilterOption = "";
        this.defaultDateFilterOption = "3M";
        this.sorter = new Sorter(new SortDescription({
            fieldName: "SnapshotDate",
            direction: SortDirection.Descending
        }));
        this.eventsPanelVisible = false;
        this.eventsPanelTop = 0;
        this.eventsPanelLeft = 0;
        this.selectedAxis = 0;
        this.chartData = new TimeseriesChart();
        this.selectedChargeCycleSnapshot = null;
        this.chargeCycleSnapshotsQuery = new GetChargeCycleSnapshotListPaginatedQuery({
            pageNo: 1,
            pageSize: 20,
            systemId: 0,
            companyId: 0,
            includeSnapshotsWithoutMeasurements: false,
            onlyDischargeEvents: false,
            startTime: null,
            endTime: null
        });
        this.trendChartQuery = new GetSystemTrendChartQuery({
            forFeature: Feature.DischargeGraph,
            timezoneOffset: moment().utcOffset(),
            axes: [
                new GetSystemTrendChartQueryModel({
                    systemId: 0,
                    companyId: 0,
                    measurementTypeId: 0,
                    measurementTypeName: null,
                    startTime: null,
                    endTime: null,
                    limitQuery: new GetSystemTrendChartLimitQueryModel({
                        nodeId: 0,
                        stringStatusId: 0
                    }),
                    dataSource: MeasurementDataSourceEnum.Measurement
                }),
                new GetSystemTrendChartQueryModel({
                    systemId: 0,
                    companyId: 0,
                    measurementTypeId: 0,
                    measurementTypeName: null,
                    startTime: null,
                    endTime: null,
                    limitQuery: new GetSystemTrendChartLimitQueryModel({
                        nodeId: 0,
                        stringStatusId: 0
                    }),
                    dataSource: MeasurementDataSourceEnum.Measurement
                })
            ]
        });
        this.measurementCategory = new MeasurementCategoryModel();
        this.componentTree = new SystemComponentTreeModel();
        this.chargeCycleSnapshots = new PaginatedEnumerableOfChargeCycleSnapshotModel();
        this.proxyTrendChartQuery = new GetSystemTrendChartQuery();
        this.chartLegend = [];
        this.scaleRanges = [];
        this.highlightedDataSetId = null;
        this.stringStates = [];
        this.dateFilterPresets = ArrayHelper.defaultDateFilters;
        this.companies = [];
        this.selectedCompany = null;
        this.systems = new Array();
        this.systemsFetched = false;
        this.measurementCategories = new Array();
        this.animate = true;
        this.autoScale = true;
        this.plotLeftAxis = false;
        this.plotRightAxis = false;
        this.syncAxes = false;
        this.showDataPoints = false;
        this.customLeftAxisMinValue = null;
        this.customLeftAxisMaxValue = null;
        this.customRightAxisMinValue = null;
        this.customRightAxisMaxValue = null;
        this.chartLegendPinned = false;
        this.chartLegendVisible = false;
        this.chartLegendPinButtonVisible = true;
        this.dischargeEventModalVisible = false;
        this.chartOptions = {
            fill: false,
            maintainAspectRatio: false,
            throttle: 100,
            layout: {
                padding: {
                    right: this.getChartPaddingLeft()
                }
            },
            scales: this.constructScales(),
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    callbacks: {
                        title: (tooltipItems) => {
                            let tooltipItem = tooltipItems[0];
                            if (!tooltipItem)
                                return "";
                            return DateHelper.formatString(`${tooltipItem.label}`);
                        },
                        label: (tooltipItem) => {
                            let label = tooltipItem.dataset.label || "";
                            if (label)
                                label = `${label}: `;
                            if (tooltipItem.parsed.y !== null) {
                                var formattedValue = MeasurementHelper.getFormattedValueForUnitOfMeasurement(tooltipItem.parsed.y, tooltipItem.dataset.measurementTypeId);
                                label += `${formattedValue} ${tooltipItem.dataset.unitOfMeasurement}`;
                            }
                            return label;
                        }
                    }
                },
                zoom: {
                    zoom: {
                        wheel: {
                            enabled: true,
                        },
                        drag: {
                            enabled: true,
                            borderColor: 'rgb(54, 162, 235)',
                            borderWidth: 1,
                            backgroundColor: 'rgba(54, 162, 235, 0.3)'
                        },
                        mode: 'xy',
                        scaleMode: 'xy',
                        onZoomComplete: this.saveChartQueryString
                    },
                    pan: {
                        enabled: true,
                        mode: "xy",
                        modifierKey: 'ctrl',
                        onPanComplete: this.saveChartQueryString
                    }
                }
            },
        };
    }
    created() {
        this.getLookups();
        this.proxyTrendChartQuery.init(this.trendChartQuery);
    }
    ;
    mounted() {
    }
    ;
    /**
     * Retrieve all lookups used by the form.
     * */
    getLookups() {
        return __awaiter(this, void 0, void 0, function* () {
            let promises = [
                companyClient
                    .getListGET()
                    .then(response => {
                    let companies = (response || []).map((item) => {
                        return {
                            value: item.companyId,
                            text: item.companyName || ""
                        };
                    });
                    this.companies = [{ value: null, text: `All companies` }].concat(companies);
                })
                    .catch(ex => {
                    HttpHelper.handleResponse(ex, () => {
                        Notifier.onServerError(ex);
                    });
                })
                    .finally(() => {
                }),
                systemsClient
                    .getSystems(false, Feature.DischargeGraph)
                    .then(response => {
                    if (!response)
                        return;
                    // The placeholder is not an option: a filter always needs a real system (CLD-1300)
                    this.systems = response;
                    this.systemsFetched = true;
                })
                    .catch(ex => {
                    HttpHelper.handleResponse(ex, () => {
                        Notifier.onServerError(ex);
                    });
                }),
                lookupsClient
                    .getMeasurementCategoriesWithMeasurementTypes(false)
                    .then(response => {
                    if (!response)
                        return;
                    this.measurementCategories = response;
                })
                    .catch(ex => {
                    HttpHelper.handleResponse(ex, () => {
                        Notifier.onServerError(ex);
                    });
                }),
                lookupsClient
                    .getStringStates()
                    .then(response => {
                    let stringStates = (response || []).filter(state => { var _a; return ((_a = state.statusName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) != "unknown"; }).map((item) => {
                        return {
                            value: item.statusId,
                            text: item.statusName || ""
                        };
                    });
                    this.stringStates = [{ value: null, text: `No limit` }].concat(stringStates);
                })
                    .catch(ex => {
                    HttpHelper.handleResponse(ex, () => {
                        Notifier.onServerError(ex);
                    });
                })
            ];
            return yield Promise.all(promises).then(() => {
                this.loadQueryString();
            });
        });
    }
    ;
    /**
     * Retrieve components for the selected system
     **/
    getSystemComponents() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.systemId) {
                let componentTree = new SystemComponentTreeModel();
                componentTree.init({});
                this.componentTree = componentTree;
                return;
            }
            ;
            return yield systemComponentTreeNodesClient
                .getSystemLocations(this.systemId)
                .then(response => {
                this.componentTree = response;
                if (this.filters) {
                    this.filters.forEach((filter) => __awaiter(this, void 0, void 0, function* () {
                        if (filter && filter.componentTreeLoaded) {
                            filter.componentTreeLoaded();
                        }
                    }));
                }
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            });
        });
    }
    ;
    /**
     * Retrieve a list of charge cycle snapshots for the selected system and time period
     **/
    getChargeCycleSnapshots() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (this.working || !this.systemId)
                return;
            this.working = true;
            let query = this.chargeCycleSnapshotsQuery;
            query.companyId = this.system.companyId;
            let queryStartTime;
            let queryEndTime;
            let invalidDates = false;
            try {
                invalidDates = this.startDateInvalid || this.endDateInvalid;
                if (!invalidDates && !this.areDatesInvalid) {
                    queryStartTime = query.startTime ? DateHelper.convertToDate(query.startTime.toString()) : null;
                    queryEndTime = query.endTime ? DateHelper.convertToDate(query.endTime.toString()) : null;
                }
            }
            catch (ex) {
                console.error(ex);
                invalidDates = true;
            }
            if (invalidDates) {
                this.working = false;
                return;
            }
            if (!DateHelper.validateDateRange((_a = query.startTime) !== null && _a !== void 0 ? _a : null, (_b = query.endTime) !== null && _b !== void 0 ? _b : null)) {
                Notifier.onWarning(`Please enter valid dates. The start date must be before the end date.`);
                this.working = false;
                return;
            }
            query.startTime = queryStartTime;
            query.endTime = queryEndTime;
            try {
                var response = yield eventsClient.searchChargeCycleSnapshots(query);
                this.chargeCycleSnapshots = response;
                this.chargeCycleSnapshotsQuery.pageNo = response.displayedPage;
                this.chargeCycleSnapshotsQuery.pageSize = response.pageSize;
                this.selectedChargeCycleSnapshot = null;
                this.filters.forEach(filter => {
                    if (filter && filter.resetFilters) {
                        filter.resetFilters();
                    }
                });
            }
            catch (ex) {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }
            finally {
                this.working = false;
            }
        });
    }
    ;
    /**
     * Retrieves trend chart data
     * **/
    getTrendChartData() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (this.working)
                return;
            let axesToPlot = [];
            let validQueries = [];
            if (this.plotLeftAxis)
                axesToPlot.push(0);
            if (this.plotRightAxis)
                axesToPlot.push(1);
            axesToPlot.forEach(axisIndex => {
                if (!this.proxyTrendChartQuery.axes)
                    return;
                let query = this.proxyTrendChartQuery.axes[axisIndex];
                if (!query)
                    return;
                validQueries.push(query);
                // force the right axis to be rendered on the right even if we don't have a left axis
                if (axisIndex && validQueries.length == 1) {
                    let fakeQuery = new GetSystemTrendChartQueryModel();
                    fakeQuery.init(query);
                    fakeQuery.nodes = [-1];
                    validQueries.unshift(fakeQuery);
                }
            });
            if (!validQueries.length) {
                Notifier.onWarning("Please review your selection for missing or invalid fields.");
                return;
            }
            let query = new GetSystemTrendChartQuery({
                forFeature: Feature.DischargeGraph,
                timezoneOffset: moment((_a = this.selectedChargeCycleSnapshot) === null || _a === void 0 ? void 0 : _a.whenEventStarted).utcOffset(),
                currentTimezoneOffset: moment().utcOffset(),
                axes: validQueries
            });
            this.saveQueryString(query);
            this.working = true;
            return yield systemTrendClient
                .getSystemDischargeChart(query)
                .then(response => {
                this.chartData = response || new TimeseriesChart();
                this.chartOptions.scales = this.constructScales();
                this.chartOptions.layout.padding.right = this.getChartPaddingLeft();
                // if there's a very small number of data points, show markers by default
                if (this.chartData.showMarkers)
                    this.showDataPoints = this.chartData.showMarkers;
                this.showOrHideDataPoints();
                this.chartLoaded = true;
                if (!this.hasData) {
                    Notifier.onWarning(`There are no records matching your criteria.`);
                }
                if (this.chartData.datasets && this.plotRightAxis)
                    this.chartData.datasets.forEach(item => {
                        if (item.yAxisID == "y-right")
                            item.borderDash = [10, 10];
                    });
                // set min / max values based on dataset.
                this.customLeftAxisMinValue = this.customRightAxisMinValue = this.chartData.minValue || 0;
                this.customLeftAxisMaxValue = this.customRightAxisMaxValue = this.chartData.maxValue || 0;
                this.constructChartLegend();
                this.forceRerender();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
                this.animate = true;
            });
        });
    }
    ;
    /**
     *  Clear selected filters
     **/
    clear() {
        this.selectedChargeCycleSnapshot = null;
    }
    ;
    setDateFilterOption(option) {
        this.dateFilterOption = option;
    }
    ;
    resetDateFilterOption() {
        this.dateFilterOption = this.defaultDateFilterOption;
    }
    ;
    selectChargeCycleSnapshot(item) {
        this.dischargeEventModalVisible = false;
        var previousStrings = this.dischargeStringIds;
        this.selectedChargeCycleSnapshot = item;
        var currentStrings = this.dischargeStringIds;
        const allStringsIncluded = previousStrings.every(stringId => currentStrings.includes(stringId));
        if (!allStringsIncluded && this.filters) {
            this.filters.forEach(filter => {
                if (filter && filter.resetFilters) {
                    filter.resetFilters();
                }
            });
        }
        this.getSystemComponents();
        this.resetChart(true);
    }
    ;
    get systemId() {
        return this.chargeCycleSnapshotsQuery.systemId;
    }
    ;
    get system() {
        return this.systems.filter(item => {
            return item.systemId == this.systemId;
        })[0];
    }
    ;
    set system(item) {
        if (!item || !item.systemId)
            return;
        this.clear();
        this.chargeCycleSnapshotsQuery.systemId = item.systemId;
        for (let i = 0; i < this.trendChartQuery.axes.length; i++) {
            let axis = this.trendChartQuery.axes[i];
            axis.systemId = item.systemId;
            axis.companyId = item.companyId;
        }
    }
    ;
    get selectPlaceholderSystem() {
        return "Please select a System";
    }
    ;
    get filtersReady() {
        return this.systemsLoaded && this.measurementTypesLoaded;
    }
    ;
    get isSystemInvalid() {
        return !this.systemId && this.searchAttempted ? true : false;
    }
    ;
    get isChargeCycleSnapshotInvalid() {
        return this.selectedChargeCycleSnapshot == null && this.searchAttempted;
    }
    ;
    get showDatePickers() {
        return this.dateFilterOption == "...";
    }
    ;
    get areDatesInvalid() {
        if (!this.searchAttempted)
            return false;
        if (this.working)
            return false;
        if (!this.chargeCycleSnapshotsQuery.startTime || !this.chargeCycleSnapshotsQuery.endTime)
            return false;
        let startTime = DateHelper.convertToDate(this.chargeCycleSnapshotsQuery.startTime.toString());
        let endTime = DateHelper.convertToDate(this.chargeCycleSnapshotsQuery.endTime.toString());
        return (startTime >= endTime) && this.searchAttempted ? true : false;
    }
    ;
    get startDateInvalid() {
        if (!this.searchAttempted)
            return false;
        if (this.working)
            return false;
        if (!this.chargeCycleSnapshotsQuery.startTime)
            return true;
        try {
            return isNaN(Date.parse(this.chargeCycleSnapshotsQuery.startTime.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    get endDateInvalid() {
        if (!this.searchAttempted)
            return false;
        if (this.working)
            return false;
        if (!this.chargeCycleSnapshotsQuery.endTime)
            return true;
        try {
            return isNaN(Date.parse(this.chargeCycleSnapshotsQuery.endTime.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    get systemsLoaded() {
        return this.systemsFetched;
    }
    ;
    get measurementTypesLoaded() {
        return this.measurementTypes && this.measurementTypes.length ? true : false;
    }
    ;
    get measurementTypes() {
        let data = new Array();
        let categories = this.measurementCategories;
        for (let i = 0; i < categories.length; i++) {
            let types = categories[i].measurementTypes;
            if (!types)
                continue;
            for (let j = 0; j < types.length; j++) {
                data.push(types[j]);
            }
        }
        return data;
    }
    ;
    // Return the String Ids in the Discharge/Charge event
    get dischargeStringIds() {
        var _a;
        try {
            if (!((_a = this.selectedChargeCycleSnapshot) === null || _a === void 0 ? void 0 : _a.componentIds))
                return [];
            let stringIds = this.selectedChargeCycleSnapshot.componentIds
                .split(" ")
                .map(stringId => Number(stringId));
            return stringIds;
        }
        catch (ex) {
            console.error("Error reading string Ids", ex);
            return [];
        }
    }
    get hasData() {
        var _a;
        return this.chartData
            && ((_a = this.chartData.labels) === null || _a === void 0 ? void 0 : _a.length) ? true : false;
    }
    ;
    /** Determines if we should show the chart legend.
    ** True if legend had been pinned or activated on mouseover.
     */
    get shouldShowChartLegend() {
        return this.chartLegendVisible || this.chartLegendPinned;
    }
    ;
    snapshotTypeString(snapshot) {
        if (snapshot.stringStatusId == StringStatusEnum.Charge)
            return "fa fa-arrow-up";
        if (snapshot.stringStatusId == StringStatusEnum.Discharge)
            return "fa fa-arrow-down";
        return "";
    }
    ;
    snapshotTypeDescriptionString(snapshot) {
        if (snapshot.stringStatusId == StringStatusEnum.Charge)
            return "Charge";
        if (snapshot.stringStatusId == StringStatusEnum.Discharge)
            return "Discharge";
        return "";
    }
    ;
    snapshotDateString(snapshot) {
        return DateHelper.convertToFriendlyMomentTimeString(snapshot.whenEventStarted);
    }
    ;
    componentNamesString(snapshot) {
        var name = snapshot.componentNames || "";
        return name
            .replace(/;/g, ", ");
    }
    ;
    getChargeCycleSnapshotClass(snapshot) {
        var _a;
        return ((_a = this.selectedChargeCycleSnapshot) === null || _a === void 0 ? void 0 : _a.snapshotId) == snapshot.snapshotId ? "selected" : "";
    }
    ;
    /**
     * Sets default page behavior, including filters.
     **/
    setDefaults() {
        this.dateFilterOption = this.defaultDateFilterOption;
    }
    ;
    /**
     * Sets date filter option and loads charge cycle snapshots if dates are valid.
     * */
    setDefaultDates() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isLoadingQueryString)
                return;
            let dateRange = this.chargeCycleSnapshotsQuery && this.chargeCycleSnapshotsQuery.startTime && this.chargeCycleSnapshotsQuery.endTime ?
                { start: this.chargeCycleSnapshotsQuery.startTime, end: this.chargeCycleSnapshotsQuery.endTime } :
                DateHelper.getDateRange(DatePresetOption.Default);
            switch (this.dateFilterOption) {
                case "W":
                    dateRange = DateHelper.getDateRange(DatePresetOption.SevenDays);
                    break;
                case "M":
                    dateRange = DateHelper.getDateRange(DatePresetOption.OneMonth);
                    break;
                case "3M":
                    dateRange = DateHelper.getDateRange(DatePresetOption.ThreeMonths);
                    break;
                case "Y":
                    dateRange = DateHelper.getDateRange(DatePresetOption.OneYear);
                    break;
            }
            this.chargeCycleSnapshotsQuery.startTime = dateRange.start;
            this.chargeCycleSnapshotsQuery.endTime = dateRange.end;
            let areDatesValid = dateRange.start && dateRange.end && DateHelper.validateDateRange(dateRange.start, dateRange.end);
            if (!areDatesValid)
                return;
            if (this.chargeCycleSnapshotsQuery.pageNo != 1) {
                this.chargeCycleSnapshotsQuery.pageNo == 1;
                return;
            }
            if (!this.system)
                return;
            this.getChargeCycleSnapshots();
        });
    }
    ;
    /**
     * Refreshes system related data once the selected system changes.
     * This will load system components and charge cycle events.
     * */
    refreshSystemData() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isLoadingQueryString)
                return;
            if (!this.system)
                return;
            this.selectedSystemChanged();
            let promises = [
                this.getChargeCycleSnapshots()
            ];
            return yield Promise.all(promises).then();
        });
    }
    ;
    onSortChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isLoadingQueryString)
                return;
            if (!this.system)
                return;
            this.chargeCycleSnapshotsQuery.sort = this.sorter.currentSort;
            this.getChargeCycleSnapshots();
        });
    }
    ;
    onPageChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isLoadingQueryString)
                return;
            if (!this.system)
                return;
            this.getChargeCycleSnapshots();
        });
    }
    ;
    onCustomDatesSet() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isLoadingQueryString)
                return;
            if (!this.showDatePickers)
                return;
            if (this.working)
                return;
            if (!this.chargeCycleSnapshotsQuery.startTime)
                return;
            if (!this.chargeCycleSnapshotsQuery.endTime)
                return;
            if (this.areDatesInvalid)
                return;
            if (!this.systemId)
                return;
            if (this.chargeCycleSnapshotsQuery.pageNo != 1) {
                this.chargeCycleSnapshotsQuery.pageNo = 1;
                return;
            }
            this.getChargeCycleSnapshots();
        });
    }
    ;
    onSelectedCompanyChanged() {
        this.chargeCycleSnapshotsQuery.systemId = null;
    }
    ;
    plot(index) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            this.searchAttempted = true;
            let validation = this.checkIfAxisIsValid(index);
            if (!validation.isValid) {
                Notifier.onWarning(validation.errorMessage ? validation.errorMessage : "Please review your selection for missing or invalid fields.");
                return;
            }
            if (!this.trendChartQuery.axes)
                return;
            if (!this.proxyTrendChartQuery.axes)
                this.proxyTrendChartQuery.axes = [];
            let axis = new GetSystemTrendChartQueryModel();
            axis.init(this.trendChartQuery.axes[index]);
            axis.systemId = this.system.systemId;
            axis.companyId = this.system.companyId;
            axis.alarmGroupId = (_a = this.selectedChargeCycleSnapshot) === null || _a === void 0 ? void 0 : _a.alarmGroupId;
            if (!index)
                this.plotLeftAxis = true;
            else
                this.plotRightAxis = true;
            this.proxyTrendChartQuery.axes[index] = axis;
            return yield this.getTrendChartData();
        });
    }
    ;
    selectAxis(index) {
        var _a, _b, _c;
        this.selectedAxis = index;
        if (!index || !this.trendChartQuery.axes)
            return;
        let axisAddedToChart = this.proxyTrendChartQuery
            && this.proxyTrendChartQuery.axes
            && this.proxyTrendChartQuery.axes[index]
            && this.proxyTrendChartQuery.axes[index].systemId ? true : false;
        if (axisAddedToChart)
            return;
        let leftAxis = this.trendChartQuery.axes[0];
        let rightAxis = this.trendChartQuery.axes[index];
        if (!leftAxis || !rightAxis)
            return;
        rightAxis.alarmGroupId = (_a = this.selectedChargeCycleSnapshot) === null || _a === void 0 ? void 0 : _a.alarmGroupId;
        rightAxis.systemId = (_b = this.system) === null || _b === void 0 ? void 0 : _b.systemId;
        rightAxis.companyId = (_c = this.system) === null || _c === void 0 ? void 0 : _c.companyId;
        rightAxis.startTime = leftAxis.startTime;
        rightAxis.endTime = leftAxis.endTime;
    }
    ;
    dischargeAxisComponentKey(index) {
        return `dischart-filter-${index}`;
    }
    ;
    clearChart(keepEvent = false) {
        this.chartData = new TimeseriesChart();
        this.chartOptions.scales = this.constructScales();
        if (!keepEvent)
            this.selectedChargeCycleSnapshot = null;
        this.forceRerender();
    }
    ;
    forceRerender() {
        this.componentKey += 1;
    }
    ;
    plotSelected() {
        this.plot(this.selectedAxis);
    }
    ;
    removePlot(index) {
        if ((!index && !this.plotLeftAxis) || (index && !this.plotRightAxis))
            return;
        if (!index)
            this.plotLeftAxis = false;
        else
            this.plotRightAxis = false;
        if (!this.proxyTrendChartQuery.axes)
            return;
        this.proxyTrendChartQuery.axes[index].nodes = [];
        if (this.filters) {
            this.filters[index].resetFilters();
        }
        if (!this.plotLeftAxis && !this.plotRightAxis) {
            this.clearChart();
            return;
        }
        this.getTrendChartData();
    }
    ;
    removeSelected() {
        this.removePlot(this.selectedAxis);
    }
    ;
    resetChart(chaningEvent = false) {
        this.chartLoaded = false;
        this.autoScale = true;
        this.searchAttempted = false;
        this.plotLeftAxis = false;
        this.plotRightAxis = false;
        this.animate = true;
        if (!chaningEvent)
            this.selectedChargeCycleSnapshot = null;
        this.chartData = null;
        this.customLeftAxisMaxValue = this.customLeftAxisMinValue = this.customRightAxisMaxValue = this.customRightAxisMinValue = null;
        if (!this.proxyTrendChartQuery.axes)
            return;
        for (let i = 0; i < this.proxyTrendChartQuery.axes.length; i++) {
            this.proxyTrendChartQuery.axes[i].nodes = [];
        }
        if (!chaningEvent && this.filters) {
            this.filters.forEach(filter => {
                if (filter && filter.resetFilters) {
                    filter.resetFilters();
                }
            });
        }
        this.clearQueryString();
        this.clearChart(chaningEvent);
    }
    ;
    pinChartLegend() {
        this.chartLegendPinned = !this.chartLegendPinned;
        this.chartLegendPinButtonVisible = window.isTouchDevice || !this.chartLegendPinned;
    }
    ;
    onChartLegendMouseEnter() {
        this.chartLegendPinButtonVisible = true;
        if (this.chartLegendVisible)
            return;
        if (this.chartLegendPinned)
            return;
        this.chartLegendVisible = true;
    }
    ;
    onChartLegendMouseLeave() {
        this.chartLegendPinButtonVisible = window.isTouchDevice || (this.chartLegendVisible && !this.chartLegendPinned);
        if (!this.chartLegendVisible)
            return;
        if (this.chartLegendPinned)
            return;
        this.chartLegendVisible = false;
    }
    ;
    resetZoom() {
        if (!this.autoScale) {
            this.autoScale = true;
            this.forceRerender();
            return;
        }
        if (this.chart) {
            this.chart.resetZoom();
        }
    }
    ;
    getChartPaddingLeft() {
        return this.plotRightAxis ? 15 : 0;
    }
    constructScales() {
        if (!this.chartData || !this.chartData.datasets || this.chartData.datasets.length <= 0)
            return {};
        var output = {};
        var xScaleName = this.chartData.datasets[0].xAxisID;
        if (xScaleName) {
            output[xScaleName] = this.constructXAxes();
        }
        this.chartData.datasets.forEach(dataset => {
            var yScaleName = dataset.yAxisID;
            if (yScaleName) {
                output[yScaleName] = this.constructYAxes(dataset);
            }
        });
        return output;
    }
    constructXAxes() {
        let displayUnit = "minute";
        let timeDisplayFormat = "DD MMM YYYY";
        if (this.chartData && this.chartData.labels) {
            if (this.chartData.displayUnit)
                displayUnit = this.chartData.displayUnit;
            if (displayUnit != "day")
                timeDisplayFormat = `${timeDisplayFormat}, HH:mm`;
        }
        return {
            id: "x-axis-0",
            type: "time",
            bounds: "ticks",
            time: {
                unit: displayUnit,
                displayFormats: {
                    day: timeDisplayFormat,
                    hour: timeDisplayFormat,
                    minute: timeDisplayFormat
                }
            },
            border: {
                display: false
            },
            ticks: {
                autoSkip: true,
                maxTicksLimit: 24, // There are 24 vertical lines on the chart, one tick (label) under each vertical line
                maxRotation: 45,
                minRotation: 45
            }
        };
    }
    ;
    constructYAxes(dataset) {
        return {
            id: dataset.yAxisID || "",
            type: "linear",
            position: (dataset.yAxisID || "").indexOf("right") < 0 ? "left" : "right",
            title: {
                display: true,
                text: dataset.title
            },
            border: {
                display: (dataset.yAxisID || "").indexOf("right") != -1
            }
        };
    }
    ;
    constructChartLegend() {
        var _a;
        let chartData = ((_a = this.chartData) === null || _a === void 0 ? void 0 : _a.datasets) || [];
        let legend = [];
        for (let i = 0; i < chartData.length; i++) {
            let axisId = chartData[i].yAxisID;
            if (!axisId)
                continue;
            let data = chartData[i];
            let hasItems = (data.data || []).filter(value => value != null && value != undefined).length;
            if (!hasItems)
                continue;
            let idx = ArrayHelper.findFirstIndex(legend, (item) => {
                return item.id == axisId;
            });
            let item = new SelectableDatasetModel(data);
            if (this.trendChartQuery && this.trendChartQuery.axes) {
                let axis = this.trendChartQuery.axes[axisId.indexOf("right") < 0 ? 0 : 1];
                if (axis) {
                    item.showLimits = axis.limitQuery
                        && axis.limitQuery.stringStatusId
                        && `${axis.limitQuery.nodeId}` == item.dataset.datasetId ? true : false;
                    if (axis.limitQuery)
                        item.showLimitsForStringStatus = axis.limitQuery.stringStatusId;
                    item.selected = this.highlightedDataSetId == item.dataset.datasetId;
                    if (item.selected)
                        item.dataset.borderWidth = this.defaultLineWidth * 3;
                }
            }
            if (idx < 0)
                legend.push({ id: axisId, items: [item] });
            else
                legend[idx].items.push(item);
        }
        this.chartLegend = legend;
    }
    ;
    onChartUpdatedEvent() {
        this.animate = true;
    }
    ;
    measurementTypeChanged(index) {
        if (!this.scaleRanges)
            return;
        this.autoScale = true;
        this.syncAxes = false;
        try {
            this.scaleRanges.splice(index, 1);
        }
        catch (ex) {
            console.error(ex);
        }
    }
    ;
    selectedSystemChanged() {
        this.chargeCycleSnapshotsQuery.companyId = this.system.companyId;
        this.chargeCycleSnapshotsQuery.pageNo = 1;
        this.resetChart();
        this.filters.forEach(filter => {
            if (filter && filter.resetMeasurementTypeIfUnavailable) {
                filter.resetMeasurementTypeIfUnavailable(this.isLithium, this.isLithiumSamsungG3);
            }
        });
    }
    ;
    synchronizeAxes() {
        if (!this.syncAxes)
            return;
        this.customRightAxisMinValue = this.customLeftAxisMinValue;
        this.customRightAxisMaxValue = this.customLeftAxisMaxValue;
    }
    ;
    synchronizeMaxLeft() {
        if (!this.syncAxes)
            return;
        this.customLeftAxisMaxValue = this.customRightAxisMaxValue;
    }
    ;
    synchronizeMaxRight() {
        if (!this.syncAxes)
            return;
        this.customRightAxisMaxValue = this.customLeftAxisMaxValue;
    }
    ;
    synchronizeMinLeft() {
        if (!this.syncAxes)
            return;
        this.customLeftAxisMinValue = this.customRightAxisMinValue;
    }
    ;
    synchronizeMinRight() {
        if (!this.syncAxes)
            return;
        this.customRightAxisMinValue = this.customLeftAxisMinValue;
    }
    ;
    checkIfAxisIsValid(index) {
        let response = { isValid: false, errorMessage: "" };
        let queries = this.trendChartQuery.axes || [];
        let query = queries[index];
        if (!this.systemId) {
            response.errorMessage = `Please select a system.`;
            return response;
        }
        if (!this.selectedChargeCycleSnapshot) {
            response.errorMessage = `Please select a discharge event.`;
            return response;
        }
        if (!query.measurementTypeId) {
            response.errorMessage = `Please select a measurement type.`;
            return response;
        }
        if (this.filters[index].measurementTypeRequiresNode && (!query.nodes || !query.nodes.length)) {
            response.errorMessage = `Please select at least one item from available locations.`;
            return response;
        }
        response.isValid = true;
        return response;
    }
    ;
    onDatasetIdSelected(datasetIndex) {
        var _a, _b, _c, _d;
        if (this.chartData == null || this.chartData.datasets == null || datasetIndex >= ((_b = (_a = this.chartData) === null || _a === void 0 ? void 0 : _a.datasets) === null || _b === void 0 ? void 0 : _b.length)) {
            return;
        }
        var dataset = this.chartData.datasets[datasetIndex];
        var legend = (_c = this.chartLegend) === null || _c === void 0 ? void 0 : _c.find(x => x.id == (dataset === null || dataset === void 0 ? void 0 : dataset.yAxisID));
        var legendItem = (_d = legend === null || legend === void 0 ? void 0 : legend.items) === null || _d === void 0 ? void 0 : _d.find(x => x.dataset.datasetId == dataset.datasetId);
        if (!legendItem) {
            return;
        }
        this.onDatasetSelected(!legendItem.selected, legendItem);
    }
    onDatasetSelected(checked, item) {
        this.highlightLine(checked, item);
    }
    ;
    onDatasetShowLimits(stringStatusId, item, axisId) {
        this.displayLimits(stringStatusId, item, axisId);
    }
    ;
    highlightLine(checked, item) {
        if (!this.chartLegend)
            return;
        this.animate = false;
        for (var i = 0; i < this.chartLegend.length; i++) {
            let legendItems = this.chartLegend[i].items;
            for (var j = 0; j < legendItems.length; j++) {
                let legendItem = legendItems[j];
                legendItem.selected = false;
                legendItem.dataset.borderWidth = this.defaultLineWidth;
            }
        }
        item.selected = checked;
        item.dataset.borderWidth = this.defaultLineWidth * (checked ? 3 : 1);
        this.highlightedDataSetId = checked ? item.dataset.datasetId || null : null;
        this.forceRerender();
    }
    ;
    displayLimits(stringStatusId, item, axisId) {
        if (!this.chartLegend)
            return;
        this.animate = false;
        let index = axisId.indexOf("right") < 0 ? 0 : 1;
        for (var i = 0; i < this.chartLegend.length; i++) {
            let legendItems = this.chartLegend[i].items;
            for (var j = 0; j < legendItems.length; j++) {
                let legendItem = legendItems[j];
                legendItem.showLimits = false;
            }
        }
        let limitQuery = new GetSystemTrendChartLimitQueryModel({
            nodeId: 0,
            stringStatusId: 0
        });
        if (stringStatusId) {
            item.showLimits = true;
            limitQuery.nodeId = parseInt(item.dataset.datasetId || "");
            limitQuery.stringStatusId = stringStatusId;
        }
        if (!limitQuery.nodeId)
            limitQuery.nodeId = 0;
        let setLimitNode = () => {
            if (!this.trendChartQuery || !this.trendChartQuery.axes)
                return;
            for (var i = 0; i < this.trendChartQuery.axes.length; i++) {
                this.trendChartQuery.axes[i].limitQuery = i == index ? limitQuery : null;
                ;
                if (this.proxyTrendChartQuery && this.proxyTrendChartQuery.axes)
                    this.proxyTrendChartQuery.axes[i] = this.proxyTrendChartQuery.axes[i];
            }
            ;
        };
        if (!stringStatusId) {
            if (this.chartData)
                this.chartData.annotations = null;
            this.chart.hideAnnotations();
            setLimitNode();
            return;
        }
        setLimitNode();
        this.plot(index);
    }
    ;
    updateChartSettings() {
        this.animate = false;
        if (!this.autoScale) {
            let leftScaleRange = new ScaleRangeModel("y-left", this.customLeftAxisMinValue || 0, this.customLeftAxisMaxValue || 0);
            this.customLeftAxisMinValue = leftScaleRange.minValue;
            this.customLeftAxisMaxValue = leftScaleRange.maxValue;
            let rightScaleRange = new ScaleRangeModel("y-right", this.customRightAxisMinValue || 0, this.customRightAxisMaxValue || 0);
            this.customRightAxisMinValue = rightScaleRange.minValue;
            this.customRightAxisMaxValue = rightScaleRange.maxValue;
        }
        // todo: this should be informed by scales returned by the server to avoid hard-coded identifiers.
        this.scaleRanges = [];
        if (this.plotLeftAxis && this.customLeftAxisMinValue != null && this.customLeftAxisMaxValue != null)
            this.scaleRanges.push(new ScaleRangeModel("y-left", this.customLeftAxisMinValue, this.customLeftAxisMaxValue));
        if (this.plotRightAxis && this.customRightAxisMinValue != null && this.customRightAxisMaxValue != null)
            this.scaleRanges.push(new ScaleRangeModel("y-right", this.customRightAxisMinValue, this.customRightAxisMaxValue));
        this.showOrHideDataPoints();
        this.forceRerender();
        this.closeChartSettingsMenu();
    }
    ;
    closeChartSettingsMenu() {
        let dropdown = this.$refs.chartSettingsDropdown;
        dropdown.close(true);
    }
    ;
    showOrHideDataPoints() {
        var _a, _b;
        let radius = this.showDataPoints ? this.defaultPointRadius : 0;
        (_b = (_a = this.chartData) === null || _a === void 0 ? void 0 : _a.datasets) === null || _b === void 0 ? void 0 : _b.forEach(dataSet => {
            dataSet.pointRadius = radius;
        });
    }
    ;
    getLimitStringStatus(item) {
        const placeholder = `Show limit...`;
        if (!item.showLimits)
            return placeholder;
        let limit = this.stringStates.filter(state => state.value == item.showLimitsForStringStatus)[0];
        return (limit === null || limit === void 0 ? void 0 : limit.text) || placeholder;
    }
    ;
    get chartStyles() {
        return {
            height: 'calc(100vh - 210px)'
        };
    }
    ;
    get selectedPlaceholderEvent() {
        if (this.selectedChargeCycleSnapshot) {
            return "";
        }
        if (!this.chargeCycleSnapshots.recordCount) {
            return this.system ? "There is no record events for the period selected" : "Please select a system to list its events";
        }
        return "Please select an event";
    }
    get selectedEventText() {
        if (this.selectedChargeCycleSnapshot) {
            return `${this.snapshotDateString(this.selectedChargeCycleSnapshot)} Duration: ${this.selectedChargeCycleSnapshot.durationText} Strings: ${this.componentNamesString(this.selectedChargeCycleSnapshot)}`;
        }
        return "";
    }
    ;
    exportToCSV() {
        var _a;
        if (!this.chartData || !this.chartData.measurements || !this.chartData.measurements[0].measurements) {
            Notifier.onWarning("Please create a chart before downloading data.");
            return;
        }
        let axesToPlot = [];
        let validQueries = [];
        if (this.plotLeftAxis)
            axesToPlot.push(0);
        if (this.plotRightAxis)
            axesToPlot.push(1);
        axesToPlot.forEach(axisIndex => {
            if (!this.proxyTrendChartQuery.axes)
                return;
            let query = this.proxyTrendChartQuery.axes[axisIndex];
            if (!query)
                return;
            validQueries.push(query);
            // force the right axis to be rendered on the right even if we don't have a left axis
            if (axisIndex && validQueries.length == 1) {
                let fakeQuery = new GetSystemTrendChartQueryModel();
                fakeQuery.init(query);
                fakeQuery.nodes = [-1];
                validQueries.unshift(fakeQuery);
            }
        });
        if (!validQueries.length) {
            Notifier.onWarning("Please review your selection for missing or invalid fields.");
            return;
        }
        let timezoneOffset = moment((_a = this.selectedChargeCycleSnapshot) === null || _a === void 0 ? void 0 : _a.whenEventStarted).utcOffset();
        let query = new GetSystemDischargeCSVQuery({
            timezoneOffset: timezoneOffset,
            currentTimezoneOffset: moment().utcOffset(),
            axes: validQueries
        });
        systemTrendClient.downloadSystemDischargeAsCsv(query)
            .then(response => {
            if (!response) {
                Notifier.onWarning("Could not download chart data.");
                return;
            }
            DownloadUtil.handleFileDownload(response);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    exportToPdf() {
        var _a;
        if (!this.chartData || !this.chartData.measurements || !this.chartData.measurements[0].measurements) {
            Notifier.onWarning("Please create a chart before downloading data.");
            return;
        }
        var datasetsSelected = [];
        if (!this.plotLeftAxis) {
            datasetsSelected.push(-1);
        }
        if (this.chartLegend) {
            this.chartLegend.forEach(legend => {
                var selected = legend.items.filter(x => x.selected);
                if (selected && selected.length > 0) {
                    var idx = legend.items.indexOf(selected[0]);
                    if (idx >= 0) {
                        datasetsSelected.push(idx);
                    }
                }
                else {
                    datasetsSelected.push(-1);
                }
            });
        }
        // Render the Chart as image
        var element = document.getElementById('trend-chart');
        let canvas = null;
        if (element != null) {
            canvas = element.toDataURL('image/png');
        }
        else {
            Notifier.onWarning("Please plot the chart first.");
            return;
        }
        let axesToPlot = [];
        let validQueries = [];
        if (this.plotLeftAxis)
            axesToPlot.push(0);
        if (this.plotRightAxis)
            axesToPlot.push(1);
        axesToPlot.forEach(axisIndex => {
            if (!this.proxyTrendChartQuery.axes)
                return;
            let query = this.proxyTrendChartQuery.axes[axisIndex];
            if (!query)
                return;
            validQueries.push(query);
            // force the right axis to be rendered on the right even if we don't have a left axis
            if (axisIndex && validQueries.length == 1) {
                let fakeQuery = new GetSystemTrendChartQueryModel();
                fakeQuery.init(query);
                fakeQuery.nodes = [-1];
                validQueries.unshift(fakeQuery);
            }
        });
        if (!validQueries.length) {
            Notifier.onWarning("Please review your selection for missing or invalid fields.");
            return;
        }
        let query = new GetSystemTrendChartQuery({
            forFeature: Feature.DischargeGraph,
            timezoneOffset: moment((_a = this.selectedChargeCycleSnapshot) === null || _a === void 0 ? void 0 : _a.whenEventStarted).utcOffset(),
            axes: validQueries
        });
        let reportQuery = new GetDischargePDFReportQuery({
            timezoneOffset: moment().utcOffset(),
            dischargeQuery: query,
            chartImage: canvas,
            dataSelectSelectedIndex: datasetsSelected
        });
        this.working = true;
        systemTrendClient.downloadSystemDischargeAsPdf(reportQuery)
            .then(response => {
            if (!response) {
                Notifier.onWarning("Could not download report data.");
                return;
            }
            let blob = new Blob([response.data], { type: 'application/pdf;base64' });
            let url = URL.createObjectURL(blob);
            var popUp = window.open(url, '_blank');
            if (popUp == null || typeof (popUp) == 'undefined') {
                alert('Please disable your pop-up blocker and try again.');
            }
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    get isLithium() {
        return this.system && this.system.batteryTypeId == BatteryTypeEnum.Lithium;
    }
    ;
    get isLithiumSamsungG3() {
        return this.system && this.system.batteryTypeId == BatteryTypeEnum.Lithium && this.system.lithiumBatteryTypeId == LithiumBatteryTypeEnum.SamsungGen3;
    }
    get measurementCategoriesVisible() {
        if (this.isLithium) {
            if (this.isLithiumSamsungG3)
                return this.measurementCategories;
            return this.measurementCategories.filter(item => item.measurementCategoryId < 5);
        }
        else {
            return this.measurementCategories.filter(item => item.measurementCategoryId < 4);
        }
    }
    ;
    get showCompanySelect() {
        return this.companies.length > 2;
    }
    ;
    get visibleSystems() {
        return this.systems.filter(item => { var _a; return ((_a = this.selectedCompany) === null || _a === void 0 ? void 0 : _a.value) == null || this.selectedCompany.value == item.companyId; });
    }
    getHelpText() {
        return `<div>
				<b class="bottom10">Chart Navigation Instructions</b>
				<ul>
					<li><b>Pan:</b> Hold the <b>Ctrl</b> key and <b>drag with the left mouse button</b> to move the chart horizontally or vertically.</li>
					<li><b>Zoom: Click and drag</b> over the desired area using the <b>left mouse button</b> or <b>hover the mouse pointer over the chart</b> and use the <b>scroll wheel</b> to zoom in or out across the entire view.</b></li>
					<li><b>Adjust Axis Range: Scroll the mouse wheel</b> while hovering over the axis to expand or contract the selected axis scale.</li>
				</ul>
			</div>`;
    }
    getPeriodTitle(item) {
        return DateHelper.getDateFilterOptionTitle(item);
    }
    clearQueryString() {
        try {
            this.$route.query.eventQuery = null;
            queryStringHelper.updateQueryString(null, "queryData");
            queryStringHelper.updateQueryString(null, "eventChart");
        }
        catch (e) {
            console.error('Error clearing Query String', e);
        }
    }
    saveQueryString(query) {
        try {
            this.clearQueryString();
            var eventQuery = this.chargeCycleSnapshotsQuery;
            eventQuery.startTime = eventQuery.startTime ? DateHelper.convertToDate(eventQuery.startTime.toString()) : null;
            eventQuery.endTime = eventQuery.endTime ? DateHelper.convertToDate(eventQuery.endTime.toString()) : null;
            // Create a single object containing all query data
            const queryData = {
                eventQuery: eventQuery,
                trendQuery: query
            };
            // Convert to JSON string and compress
            const jsonString = JSON.stringify(queryData);
            const data = new TextEncoder().encode(jsonString);
            const compressed = pako.deflate(data);
            // Convert to base64url without using Buffer
            const base64 = btoa(String.fromCharCode.apply(null, compressed));
            const base64url = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
            // Update query string
            queryStringHelper.updateQueryString(base64url, "queryData");
        }
        catch (e) {
            console.error('Error saving Query String', e);
        }
    }
    // Replace existing saveChartQueryString method
    saveChartQueryString(chartInstance) {
        var _a, _b, _c;
        let chart = chartInstance.chart;
        try {
            var chartState = {
                x: ((_a = chart.scales['x-axis-0']) === null || _a === void 0 ? void 0 : _a.min) !== undefined ? {
                    min: chart.scales['x-axis-0'].min,
                    max: chart.scales['x-axis-0'].max
                } : null,
                yLeft: ((_b = chart.scales['y-left']) === null || _b === void 0 ? void 0 : _b.min) !== undefined ? {
                    min: chart.scales['y-left'].min,
                    max: chart.scales['y-left'].max
                } : null,
                yRight: ((_c = chart.scales['y-right']) === null || _c === void 0 ? void 0 : _c.min) !== undefined ? {
                    min: chart.scales['y-right'].min,
                    max: chart.scales['y-right'].max
                } : null
            };
            // Convert to JSON string and compress
            const jsonString = JSON.stringify(chartState);
            const data = new TextEncoder().encode(jsonString);
            const compressed = pako.deflate(data);
            // Convert to base64url without using Buffer
            const base64 = btoa(String.fromCharCode.apply(null, compressed));
            const base64url = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
            // Update query strings
            let queryParam = [
                { value: base64url, parameterName: "eventChart" }
            ];
            queryStringHelper.updateQueryStrings(queryParam);
        }
        catch (e) {
            console.error('Error saving ChartQueryString', e);
        }
    }
    loadQueryString() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const encodedData = this.$route.query.queryData;
            if (!encodedData)
                return;
            try {
                this.isLoadingQueryString = true;
                // Convert base64url to binary data
                const base64 = encodedData.replace(/-/g, '+').replace(/_/g, '/');
                const binaryString = atob(base64);
                const compressed = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    compressed[i] = binaryString.charCodeAt(i);
                }
                // Decompress data
                const decompressed = pako.inflate(compressed);
                const jsonString = new TextDecoder().decode(decompressed);
                const data = JSON.parse(jsonString);
                if (!data)
                    return;
                if (data.eventQuery) {
                    this.chargeCycleSnapshotsQuery = GetChargeCycleSnapshotListPaginatedQuery.fromJS(data.eventQuery);
                    this.chargeCycleSnapshotsQuery.startTime = new Date(data.eventQuery.startTime);
                    this.chargeCycleSnapshotsQuery.endTime = new Date(data.eventQuery.endTime);
                    this.dateFilterOption = "...";
                }
                if (data.trendQuery) {
                    this.proxyTrendChartQuery = GetSystemTrendChartQuery.fromJS(data.trendQuery);
                }
                if (this.chargeCycleSnapshotsQuery.systemId && this.proxyTrendChartQuery.axes[0].alarmGroupId) {
                    this.working = false;
                    yield this.getChargeCycleSnapshots();
                    this.selectedChargeCycleSnapshot = this.chargeCycleSnapshots.records
                        .find(s => s.alarmGroupId == this.proxyTrendChartQuery.axes[0].alarmGroupId) || null;
                    yield this.getSystemComponents();
                    yield nextTick();
                }
                this.plotLeftAxis = ((_a = this.proxyTrendChartQuery.axes) === null || _a === void 0 ? void 0 : _a.length) > 0;
                this.plotRightAxis = ((_b = this.proxyTrendChartQuery.axes) === null || _b === void 0 ? void 0 : _b.length) > 1;
                yield this.getTrendChartData();
                this.loadChartQueryString();
            }
            catch (e) {
                console.error("Error reading trendQuery options", e);
            }
            finally {
                this.isLoadingQueryString = false;
            }
        });
    }
    // Replace existing loadChartQueryString method
    loadChartQueryString() {
        if (!this.$route.query.eventChart)
            return;
        try {
            // Convert base64url to binary data
            const base64 = this.$route.query.eventChart.replace(/-/g, '+').replace(/_/g, '/');
            const binaryString = atob(base64);
            const compressed = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                compressed[i] = binaryString.charCodeAt(i);
            }
            // Decompress data
            const decompressed = pako.inflate(compressed);
            const jsonString = new TextDecoder().decode(decompressed);
            const eventChart = JSON.parse(jsonString);
            if (!eventChart)
                return;
            let chart = this.chart.chartInstance;
            var setZoom = (scale, option) => {
                if (!scale || !option)
                    return;
                scale.options.min = option.min;
                scale.options.max = option.max;
            };
            setZoom(chart.scales['x-axis-0'], eventChart.x);
            setZoom(chart.scales['y-left'], eventChart.yLeft);
            setZoom(chart.scales['y-right'], eventChart.yRight);
            chart.update();
            let resetZoom = (scale) => {
                if (!scale)
                    return;
                scale.options.min = undefined;
                scale.options.max = undefined;
            };
            resetZoom(chart.scales['x-axis-0']);
            resetZoom(chart.scales['y-left']);
            resetZoom(chart.scales['y-right']);
        }
        catch (e) {
            console.error('Error reading eventChart options', e);
        }
    }
    get isStandardOrHigher() {
        return this.licenseState.isStandardEdition ||
            this.licenseState.isPremiumEdition ||
            this.licenseState.appEdition === AssureEditionEnum.PowershieldCloudStandard;
    }
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], DischargeVue.prototype, "loginState", void 0);
__decorate([
    State("licenseModule"),
    __metadata("design:type", typeof (_b = typeof LicenseState !== "undefined" && LicenseState) === "function" ? _b : Object)
], DischargeVue.prototype, "licenseState", void 0);
__decorate([
    Ref("filters"),
    __metadata("design:type", Object)
], DischargeVue.prototype, "filters", void 0);
__decorate([
    Ref("chart"),
    __metadata("design:type", Object)
], DischargeVue.prototype, "chart", void 0);
__decorate([
    Watch("filtersReady"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DischargeVue.prototype, "setDefaults", null);
__decorate([
    Watch("dateFilterOption"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
], DischargeVue.prototype, "setDefaultDates", null);
__decorate([
    Watch("chargeCycleSnapshotsQuery.systemId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
], DischargeVue.prototype, "refreshSystemData", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
], DischargeVue.prototype, "onSortChanged", null);
__decorate([
    Watch("chargeCycleSnapshotsQuery.pageNo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
], DischargeVue.prototype, "onPageChanged", null);
__decorate([
    Watch("chargeCycleSnapshotsQuery.startTime"),
    Watch("chargeCycleSnapshotsQuery.endTime"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
], DischargeVue.prototype, "onCustomDatesSet", null);
__decorate([
    Watch("selectedCompany"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DischargeVue.prototype, "onSelectedCompanyChanged", null);
__decorate([
    Watch("syncAxes"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DischargeVue.prototype, "synchronizeAxes", null);
DischargeVue = __decorate([
    Component({
        name: "DischargeVue",
        components: {
            TrendGraphVue,
            DischargeGraphAxisVue,
            VerticalSplitterVue,
            AutomaticDischargeReportSettingsVue
        }
    })
], DischargeVue);
export default DischargeVue;
